import { Box, CancelButton, PrimaryButton } from "@crayon/design-system-react";

interface MigrationFormActionButtonsProps {
  isSaveDisable?: boolean;
  isSaveLoading?: boolean;
  onSkipClick?: () => void;
}

const MigrationFormActionButtons = ({
  isSaveDisable = false,
  isSaveLoading = false,
  onSkipClick,
}: MigrationFormActionButtonsProps) => (
  <Box display="flex" justifyContent={onSkipClick ? "space-between" : "flex-end"}>
    {onSkipClick && (
      <CancelButton disabled={isSaveLoading} onClick={onSkipClick} testId="skip-button">
        Skip
      </CancelButton>
    )}
    <PrimaryButton
      type="submit"
      loading={isSaveLoading}
      disabled={isSaveDisable}
      testId="migrate-button"
    >
      Migrate
    </PrimaryButton>
  </Box>
);

export default MigrationFormActionButtons;
